<template>
    <img ref="img"
         @load="imageLoaded"
         v-zoomable="isImageZoomable"
         loading="lazy"
         :class="forcedAspectRatio ? `aspect-ratio-${section.mediaAspectRatio}` : null"
         :style="cornerRadiusStyle"
         :src="getImageUrl"
         :alt="columnMedia.altTag ? columnMedia.altTag : 'Image alt tag'"
    >
</template>

<script>
import {hexToHSL, resolveColor} from "../../../../common/helpers.js";
import {mapGetters} from "vuex";
import {resolveLogoWallLogoUrl} from "@/scripts/common/utilities/logoWallLogos.js";

    export default {
        name: "PlaceColumnMediaContent",
        props: ['section', 'columnMedia', 'placeholderImage'],
        mounted() {
            if(this.section && this.section.type === 'LogoWall' && !this.$store.state.darkMode) {
                this.$store.state.darkMode = hexToHSL(this.resolveColor("background")).l < 0.2;
            }
        },
        methods: {
            imageLoaded() {
                this.$store.commit("recalculateScrollTriggers");
            },
        },
        computed: {
            ...mapGetters(
                "design",
                ["resolveColor"]
            ),
            isImageZoomable() {
                return this.section && this.section.type !== 'LogoWall';
            },
            forcedAspectRatio() {
                return !!this.section?.mediaAspectRatio;
            },
            getImageUrl() {
                const fallbackUrl = this.placeholderImage ? `/example_project_images/${this.placeholderImage}` : null;
                if (this.section?.type === 'LogoWall') {
                    return resolveLogoWallLogoUrl(this.columnMedia, this.$store.state.darkMode, fallbackUrl);
                }
                return this.columnMedia.croppedImageUrl || this.columnMedia.url || fallbackUrl;
            },
            cornerRadiusStyle() {
                if (this.columnMedia?.mockupSettings) {
                    return null;
                }
                return { borderRadius: `${this.section?.cornerRadiusPx ?? 0}px` };
            },
        }
    }
</script>
